export const pluckValuesFromArrayWithSpecificKey = (array: any[] = [], key: string, secondaryKey?: string) => {
  return array.map(item => (secondaryKey ? `${item[key]} ${item[secondaryKey]}` : item[key]));
};

export const pluckIntValuesFromArrayWithSpecificKey = (array: any[] = [], key: string) => {
  return array.map(item => item[key]);
};
